import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { firebaseApp } from '../firebase/config';

/**
 * Creates a separate auth instance to handle operations without affecting the main auth state
 * @returns {auth} A separate firebase auth instance
 */
export const createSecondaryAuthInstance = () => {
  const firebaseConfig = firebaseApp.options;
  const secondaryApp = initializeApp(firebaseConfig, 'secondary-app-' + Date.now());
  const secondaryAuth = getAuth(secondaryApp);
  return { 
    auth: secondaryAuth,
    app: secondaryApp
  };
};

/**
 * Safely creates a user with a secondary auth instance without affecting the main user session
 * @param {string} email - User email
 * @param {string} password - User password
 * @returns {Promise<Object>} - User credential or error
 */
export const safelyCreateUser = async (email, password) => {
  const { auth: secondaryAuth, app: secondaryApp } = createSecondaryAuthInstance();
  
  try {
    const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error };
  } finally {
    // This won't affect the main auth instance
    try {
      await secondaryAuth.signOut();
      secondaryApp.delete().catch(console.error);
    } catch (e) {
      console.warn("Error cleaning up secondary auth:", e);
    }
  }
};
